import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SelectFormModal({
  onClose,
  title,
  forms,
  patient_id,
  patient_name,
  mode,
}) {
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setSearchInput("");
    setSearchQuery("");
    document.body.style.overflow = "hidden";
    setTimeout(() => setIsVisible(true), 10);
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  const eligibleForms =
    mode === "send" ? forms.filter((form) => form.fillable_at_home) : forms;

  const filteredForms = eligibleForms.filter((form) => {
    return form.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 pointer-events-auto">
      {/* Background overlay */}
      <div
        className="absolute inset-0"
        onClick={() => {
          setIsVisible(false);
          setTimeout(onClose, 300);
        }}
      />

      {/* Drawer container */}
      <div
        className={`w-full bg-white rounded-t-xl transition-transform duration-300 ${
          isVisible ? "translate-y-0" : "translate-y-full"
        } fixed bottom-0 left-0 right-0 mx-auto shadow-lg max-h-[55vh] flex flex-col`}
      >
        {/* Fixed Header and Search */}
        <div className="px-4 sm:px-6 pt-6 pb-2 sticky rounded-t-xl shadow-sm top-0 bg-white z-10">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              {title}
            </h2>
            <button
              onClick={() => {
                setIsVisible(false);
                setTimeout(onClose, 300);
              }}
              className="text-gray-800 hover:text-gray-700"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Search Form */}
          <form
            className="mb-4"
            onSubmit={(e) => {
              e.preventDefault();
              setSearchQuery(searchInput.trim());
            }}
          >
            <div className="relative">
              <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="search"
                id="default-search"
                className="block w-full py-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="search forms"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <button
                type="submit"
                className="text-white absolute end-2.5 bottom-2 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"
              >
                Search
              </button>
            </div>
          </form>
        </div>

        {/* Scrollable Form Grid */}
        <div className="px-4 sm:px-6 pb-6 overflow-y-auto scrollbar-hide">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredForms.map((form) => (
              <div
                key={form.id}
                className="flex items-start gap-3 border border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer"
                onClick={() => {
                  const route = mode === "send" ? "/send-form" : "/fill-form";
                  navigate(route, {
                    state: {
                      formName: form.name,
                      contant: form.structure,
                      template_id: form.id,
                      patient_id,
                      patient_name,
                    },
                  });
                }}
              >
                <img
                  src="/PDF-ICON.svg"
                  alt="PDF icon"
                  className="w-6 h-6 mt-1"
                />
                <div>
                  <div className="font-medium text-gray-900">{form.name}</div>
                  {form.fillable_at_home && mode === "send" && (
                    <div className="flex items-center gap-1 rounded-md text-sm font-medium bg-green-100 py-1 px-2.5 text-green-800 mt-1">
                      <svg
                        className="w-4 h-4 text-green-800"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fillRule="evenodd"
                          d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Patient Can Fill at Home</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {filteredForms.length === 0 && (
            <p className="text-center text-sm text-gray-400 mt-6">
              No forms found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
